import { render, staticRenderFns } from "./text-marquee.vue?vue&type=template&id=26c01c3e&scoped=true&"
import script from "./text-marquee.vue?vue&type=script&lang=js&"
export * from "./text-marquee.vue?vue&type=script&lang=js&"
import style0 from "./text-marquee.vue?vue&type=style&index=0&id=26c01c3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c01c3e",
  null
  
)

export default component.exports